import React from 'react';
import { RhDateInput } from '../../../../../../dum';
import { IExpense } from '../expense-form';
import { usePrefillFromSupplierAccount } from '../use-prefill-from-supplier-account';
import { EXPENSE_FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

// On create, changing the expense date recomputes the expected payment date
// from the supplier's credit days. On edit, the loaded payment date is kept.
export function ExpenseDateInput() {
    const { recomputePaymentDate } = usePrefillFromSupplierAccount();

    return (
        <RhDateInput
            name={'date'}
            label={shortLabel(EXPENSE_FIELD_LABELS.date)}
            onChange={(val) => recomputePaymentDate(val as IExpense['date'])}
        />
    );
}
